import "./AddUsersButton.css";

function AddUsersButton({
  label,
  onClick,
  disabled = false,
  type = "button",
  className = "",
  "data-testid": dataTestId,
  ariaLabel,
  width,
}) {
  const buttonStyle = width ? { width } : undefined;

  return (
    <button
      type={type}
      className={`btn-adc-users ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      data-testid={dataTestId}
      style={buttonStyle}
    >
      {label}
    </button>
  );
}

export default AddUsersButton;
